// Entry point for react app
import React from "react";
import { Main } from "./screens";
import "./App.css";

const App = () => {
  return <Main />;
};

export default App;
